'use client';

import { palette } from '@instamenu/ui-vanilla-extract';
import { styledCloseButton } from './close-icon.css';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import Link from 'next/link';
import { X } from 'lucide-react';

export const CloseIconUI = ({ path, returnPath }: { path?: () => void; returnPath?: string }) => {
  const router = useRouter();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        event.preventDefault(); // Prevent any default behavior of the Esc key (e.g., closing the browser tab)
        if (path) path();
        else router.back();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [path, router]);
  return !returnPath ? (
    <div className={styledCloseButton} onClick={path ? path : () => router.back()}>
      <X size={11} color={palette.gray900} />
    </div>
  ) : (
    <Link className={styledCloseButton} href={returnPath} scroll={false}>
      <X size={11} color={palette.gray900} />
    </Link>
  );
};
